import { captureMessage } from '@sentry/react';
import { FieldErrors } from 'react-hook-form';

export function captureFormValidationError(formReference: string, errors: FieldErrors | unknown) {
  captureMessage(`Validation failed - ${formReference}:\n${JSON.stringify(errors)}`);
}

export function captureUnexpectedState(message: string, state: unknown) {
  captureMessage(`Unexpected state: ${message}\n${JSON.stringify(state)}`);
}
